module.exports = __webpack_public_path__ + "assets/img/login-image.18df9acc.png";